var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "{{amount}} €";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, '.');
    decimal   = defaultOption(decimal, ',');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

;(function() {
  // Get the recommendations slider container
  const slider = document.getElementById('recommendations-slider');
  if (!slider) return;

  slider.classList.add('hidden');

  let currentIndex = 0;
  let touchStartX = 0;
  let cartUpdateUnsub;

  // ————— Helpers —————

  // Fetch up to 6 recommendations for a given product
  function fetchRecs(productId) {
    return fetch(`/recommendations/products.json?product_id=${productId}&limit=6`)
        .then(res => res.json())
        .then(data => data.products || []);
  }

  // Fetch fallback products by ID array
  function fetchDefaults(ids) {
    return Promise.all(
        ids.map(id => fetch(`/products/${id}.js`).then(res => res.json()))
    );
  }

  // Render the slide items (up to 6) into the UL
  function renderSlides(products) {
    // Start with an empty string
    let slidesHTML = '';

    products.slice(0, 6).forEach(prod => {
      const variants = prod.variants || [];
      const hasVariants = variants.length > 1;
      const imageUrl = prod.featured_image || '';

      slidesHTML += `
      <li class="recommendations__slide">
        <a href="${prod.url}" class="recommendations__link">
          <img src="${imageUrl}&height=160" alt="${prod.title}" class="recommendations__image">
          <h4 class="recommendations__title">${prod.title}</h4>
          <p class="recommendations__price">${Shopify.formatMoney(prod.price)}</p>
        </a>

        <product-form data-hide-errors="true">
          <form>
            <input type="hidden" name="quantity" value="1" />
            ${
                hasVariants
                    ? `<select name="id" class="recommendations__variant">
                           ${variants
                        .map(v =>
                            `<option value="${v.id}">${v.title} (${Shopify.formatMoney(v.price)})</option>`
                        )
                        .join('')}
                         </select>`
                    : `<input type="hidden" name="id" value="${variants[0].id}" />`
            }
            <button type="submit" class="recommendations__add button">
              In den Warenkorb
              <span class="loading-overlay__spinner hidden"></span>
            </button>
            <div class="product-form__error-message-wrapper" hidden>
              <p class="product-form__error-message"></p>
            </div>
          </form>
        </product-form>
      </li>
    `;
    });

    // Inject all at once
    const ul = document.querySelector('.recommendations__slides');
    ul.innerHTML = slidesHTML;
    slider.classList.remove('hidden');
  }

  // Set up prev/next & touch swipe behavior
  function initSlider() {
    const container = document.querySelector('.recommendations__container');
    const slides = document.querySelectorAll('.recommendations__slide');
    const prevBtn = document.querySelector('.recommendations__prev');
    const nextBtn = document.querySelector('.recommendations__next');
    const slideWidth = container.clientWidth / 2;

    function updatePosition() {
      const maxIndex = Math.max(0, slides.length - 2);
      currentIndex = Math.min(Math.max(0, currentIndex), maxIndex);
      document.querySelector('.recommendations__slides').style.transform =
          `translateX(${-currentIndex * slideWidth}px)`;
    }

    prevBtn.onclick = () => { currentIndex--; updatePosition(); };
    nextBtn.onclick = () => { currentIndex++; updatePosition(); };
    window.addEventListener('resize', updatePosition);

    // Touch/swipe handling
    container.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    container.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) { // threshold
        currentIndex += dx < 0 ? 1 : -1;
        updatePosition();
      }
    });

    updatePosition();
  }

  // Given a cart JSON, pick recs or defaults and re-render
  function updateRecs(cart) {
    const items = cart.items;
    const promise = items.length
        ? fetchRecs(items[0].product_id)
        : fetchDefaults(slider.dataset.defaultProductIds.split(','));

    promise.then(products => {
      renderSlides(products);
      initSlider();
    });
  }

  // Fetch cart and trigger updateRecs
  function onCartChange() {
    fetch('/cart.js')
        .then(res => res.json())
        .then(cart => updateRecs(cart));
  }

  // ————— Subscribe to theme’s cartUpdate pub/sub —————

  function initSubscriptions() {
    if (typeof subscribe !== 'function' || !PUB_SUB_EVENTS) return;

    cartUpdateUnsub = subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        event => {
          onCartChange();
        }
    );
  }

  // ————— Initialization —————

  initSubscriptions();
  onCartChange();

  // If you ever tear this component down:
  // window.addEventListener('beforeunload', () => {
  //   if (cartUpdateUnsub) cartUpdateUnsub();
  // });
})();